import React, { useEffect } from "react";
import { Grid, GridItem, Flex, Image } from "@chakra-ui/react";
import Layout from "../../../layout";
import { useDispatch, useSelector } from "react-redux";
import CountCard from "../components/CountCard";

const GenericDashboardScreen = ({
  header,
  iconUrl,
  screenIcon,
  showDateFilters,
  bgImage,
  fetchAction,
  dataSelector,
  screenName,
  handleCardClick,
  dateFilterHandler,
}) => {
  const dispatch = useDispatch();

  const dashboardData = useSelector(dataSelector);

  useEffect(() => {
    const payload = {
      source: "Web",
      screen: screenName,
    };
    dispatch(fetchAction(payload));
  }, [dispatch, screenName, fetchAction]);

  return (
    <Layout
      header={header}
      iconUrl={iconUrl}
      showDateFilters={showDateFilters}
      handleDateFilterApply={dateFilterHandler}
    >
      <Flex
        justifyContent="center"
        alignItems="center"
        marginBottom="20px"
        bgImage={bgImage}
        bgRepeat="no-repeat"
        bgSize="cover"
        p="10px"
      >
        <Image
          src={screenIcon}
          alt={`${header} Icon`}
          width="200px"
          height="200px"
        />
      </Flex>
      <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={6}>
        {dashboardData?.map((item) => (
          <GridItem
            key={item.label}
            onClick={() => handleCardClick(item.label)}
          >
            <CountCard label={item.label} value={item.value} />
          </GridItem>
        ))}
      </Grid>
    </Layout>
  );
};

export default GenericDashboardScreen;
